<template lang="html">
  <div class="bim__tumbler__wrp">
    <div
      class="bim__tumbler"
      :class="{
      active: isChecked,
      size__s: size === 's',
      size__m: size === 'm',
      size__l: size === 'l'
    }">
      <input
        class="form__input"
        type="radio"
        :value="radioValue || observableValue"
        :checked="isChecked"
        :name="name"
        @click="updateValue"
        :id="id"
        @blur="$emit('blur')"
      />
      <div
        class="tumbler__circle"
        :class="{ active: isChecked }"
      ></div>
    </div>
    <label v-if="label" :for="id" class="tumbler__label">{{ label }}</label>
  </div>
</template>

<script>
  export default {
    name: 'bimTumbler',
    props: {
      /**
       * Имя тумблера
       */
      name: {
        type: String,
        required: true
      },
      /**
       * Значение тумблера (берется из v-model)
       */
      value: {
        type: [Boolean, String],
        default: false
      },
      /**
       * Значение, которое должно вернуться в v-model при выборе радио-кнопки
       */
      radioValue: {
        type: [String, Number, Boolean],
        default: null
      },
      /**
       * Подпись (label) тумблера
       */
      label: {
        type: String,
        default: ''
      },
      /**
       * id тумблера. Прописывается для input и label одинаковый
       */
      id: {
        type: String,
        default: function () { return 'radio-id-' + this._uid }
      },
      /**
       * Возможность не снимать активный радиобаттон
       */
      persistentRadio: {
        type: Boolean,
        default: true
      },
      /**
       * Размер тумблера
       * @values s, m, l
       */
      size: {
        type: String,
        default: 'm',
        validator (value) {
          return ['s', 'm', 'l'].indexOf(value) !== -1
        }
      },
      disabled: { // заблокирована кнопка или нет
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        observableValue: this.value
      }
    },
    computed: {
      isChecked () {

        if (this.radioValue) {
          return this.observableValue === this.radioValue
        }

        return this.observableValue === true
      }
    },
    methods: {
      updateValue () {

        if (this.disabled) {
          return
        }

        if (this.radioValue && !this.persistentRadio && this.observableValue === this.radioValue) {

          this.observableValue = ''

        } else {

          this.observableValue = this.radioValue ? this.radioValue : !this.observableValue
        }

        /**
         * Событие срабатывает при изменении тумблера
         * @property value
         */
        this.$emit('input', this.observableValue)
      }
    },
    watch: {
      value (value) {
        this.observableValue = value
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bim__tumbler__wrp {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
  }

  .tumbler__label {
    margin-left: 12px;
    cursor: pointer;
  }

  .bim__tumbler {
    background: #dbdbdb;
    position: relative;
    border-radius: 100px;
    transition: background 0.2s;
  }

  .bim__tumbler.active {
    background: $primary-color
  }

  .form__input {
    -webkit-appearance: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    margin: 0;
    opacity: 0;
    z-index: 2;
    cursor: pointer;
  }

  .tumbler__circle {
    position: absolute;
    top: 3px;
    right: 3px;
    background-color: #ffffff;
    border-radius: 50%;
    transition: transform 0.25s;
    pointer-events: none;
    z-index: 2;
  }

  /*size m*/
  .bim__tumbler.size__m,
  .bim__tumbler.size__m .form__input {
    width: 48px;
    height: 25px;
  }

  .bim__tumbler.size__m .tumbler__circle {
    width: 19px;
    height: 19px;
    transform: translateX(-23px);
  }

  /*size s*/
  .bim__tumbler.size__s,
  .bim__tumbler.size__s .form__input {
    width: 34px;
    height: 20px;
    border-radius: 20px;
  }

  .bim__tumbler.size__s .tumbler__circle {
    width: 14px;
    height: 14px;
    transform: translateX(-14px);
  }

  /*size l*/
  .bim__tumbler.size__l,
  .bim__tumbler.size__l .form__input {
    width: 60px;
    height: 30px;
    border-radius: 20px;
  }

  .bim__tumbler.size__l .tumbler__circle {
    width: 24px;
    height: 24px;
    transform: translateX(-30px);
  }

  .tumbler__circle.active {
    transform: translateX(0) !important
  }
</style>
